export default __webpack_public_path__ + "static/media/drynessActive.68b04787.svg";